import { STEPS } from '../steps/util';

export const initialState = {
	placeDetails: {},
	currentIndex: 0,
	websiteType: 0,
	siteLogo: {
		id: '',
		thumbnail: '',
		url: '',
		width: 160,
	},
	activePalate: 0,
	websiteTypography: 0,
	stepsLength: Object.keys(STEPS).length,
	businessImagesDownloaded: false,
	hasBusinessInfo: false,

	// Business Information.
	businessName: '',
	businessAddress: '',
	businessEmail: starterTemplates.adminEmail,
	businessPhone: '',

	// Template Information.
	templateId: 0,
	templateResponse: null,
	visitedSites: [],

	// Import statuses.
	completionReady: false,
	skipImport: starterTemplates.skipImport,
	reset: starterTemplates.reset,
	themeStatus: false,
	pluginStatus: false,
	requiredPlugins: [],
	importStatusLog: '',
	resetData: [],
	importStart: false,
	importEnd: false,
	importPercent: 0,
	businessWork: ""
};

const reducer = (state = initialState, { type, ...rest }) => {
	switch (type) {
		case "set":
			return { ...state, ...rest };
		default:
			return state;
	}
};

export default reducer;
